"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var AppBand_1 = require("../../components/globals/AppBand");
var Top = /** @class */ (function (_super) {
    __extends(Top, _super);
    function Top() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = "100%";
        return _this;
    }
    Top.prototype.beforeCreate = function () {
        document.title = "自宅でできる介護リハビリ - リハプラン";
        document.querySelector("meta[property='og:title']").setAttribute('content', "自宅でできる介護リハビリ - リハプラン");
        document.querySelector("meta[name='description']").setAttribute('content', "リハプランは、特設サイト「自宅でできる介護リハビリ」にて約2,200種類の運動マニュアルを無償提供します。新型コロナウイルス影響でデイサービスに通えなくなった高齢者の自宅でのリハビリ・介護予防にお役立てください。");
        document.querySelector("meta[property='og:description']").setAttribute('content', "リハプランは、特設サイト「自宅でできる介護リハビリ」にて約2,200種類の運動マニュアルを無償提供します。新型コロナウイルス影響でデイサービスに通えなくなった高齢者の自宅でのリハビリ・介護予防にお役立てください。");
        document.querySelector("meta[name='keywords']").setAttribute('content', "自宅でできる,介護リハビリ,リハプラン");
        document.querySelector("link[rel='canonical']").setAttribute('href', "https://rehaplan.jp/keeprehab/");
    };
    Top.prototype.mounted = function () {
        this.$ga.event({
            eventCategory: '【STOP_COVID_19】トップページに遷移',
            eventAction: '【STOP_COVID_19】トップページに遷移',
            eventLabel: '【STOP_COVID_19】トップページに遷移'
        });
    };
    Top.prototype.toForm = function (event) {
        var self_ = this;
        self_.$router.push({ path: '/keeprehab/form' });
    };
    Top.prototype.toLogin = function (event) {
        var self_ = this;
        self_.$router.push({ path: '/keeprehab/login' });
    };
    Top.prototype.data = function () {
        return {
            services: [
                "facebook",
                "twitter"
            ]
        };
    };
    Top = __decorate([
        vue_property_decorator_1.Component({
            components: {
                AppBand: AppBand_1.default
            }
        })
    ], Top);
    return Top;
}(vue_property_decorator_1.Vue));
exports.default = Top;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/top/Top.vue
// module id = QG3w
// module chunks = 1